import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// ✅ Redux
import { Provider } from "react-redux";
import { store } from "../src/Component/Store/store"; // tamaro store path

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);